import React from 'react'
import PropTypes from 'prop-types'

const renderCircle = (count, stepCount) => {
  const collectionCircle = []
  for(let i = 0; i< count; i++){
    collectionCircle.push(
      <div key={`step-number-${i}`} className={`circle ${i === stepCount - 1 ? 'active' : 'not-active'}`}>
        <span className='step-number'>{i + 1}</span>
      </div>
    )
  }
  return collectionCircle 
}

const StepNavigation = ({numberForm, allCount}) => {
  return(
    <div className="container-step-navigation">
      <div className="step-navigation">
        {renderCircle(allCount, numberForm).map(item => item)}
      </div>
    </div>
  )
}

StepNavigation.propTypes = {
  numberForm: PropTypes.number.isRequired,
  allCount: PropTypes.number.isRequired,
}

export default StepNavigation